import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class PopupBlock extends React.Component {
  state = { open: true }

  ref = null;

  componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClick);
    document.getElementsByTagName('html')[0].classList.add('lock');
  };

  componentWillUnmount = () => document.removeEventListener('mousedown', this.handleClick);

  handleClick = (e) => {
    if (this.ref.contains(e.target)) {
      return null;
    }
    const html = document.getElementsByTagName('html')[0];
    if (html.classList.contains('lock')) {
      html.classList.remove('lock');
    }
    return this.setState({ open: false });
  }

  handleNavigate = () => {
    const { properties: { ctaUrl }, history } = this.props;
    return history.push(`${ctaUrl}`);
  }

  render() {
    const { open } = this.state;
    const { text, buttonText, title } = this.props.properties;
    if (!open) return null;
    return (
      <div className="js-popup-block-inner">
        <div ref={(ref) => { this.ref = ref; }} className="js-popup-holder">
          <div className="title h5">{title}</div>
          <button
            type="button"
            className="btn btn-absolute btn-square text-center text-white"
            onClick={() => this.setState({ open: false })}
          >
            <i className="material-icons">close</i>
          </button>
          <div className="html-holder" dangerouslySetInnerHTML={{ __html: text }} />
          <button
            type="button"
            onClick={this.handleNavigate}
            className="btn btn-green btn-lg h3 float-right"
          >
            {buttonText}
          </button>
        </div>
      </div>
    );
  }
}

PopupBlock.propTypes = {
  properties: PropTypes.object,
  history: PropTypes.object
};

export default withRouter(PopupBlock);
